import { Tooltip } from '@patternfly/react-core'
import { InfoCircleIcon } from '@patternfly/react-icons'
import * as React from 'react'

const infoTooltipIcon = {
  marginLeft: '0.5em',
  verticalAlign: '-0.125em',
}

interface ToolTipIconProps {
  content: React.ReactNode
}

export const InfoTooltip = ({ content }: ToolTipIconProps) => {
  return (
    <Tooltip content={content}>
      <InfoCircleIcon style={infoTooltipIcon} />
    </Tooltip>
  )
}
